import {
  CloseCircleOutlined,
  FilterOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons'
import { Button, Pagination, Space, Tabs, Tooltip } from 'antd'
import FileDownload from 'js-file-download'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { Fragment, memo, useCallback, useEffect } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import uuid from 'uuid'
import AccessControlAction from '../../components/AccessControlAction'
import {
  CellEclipseBox,
  TableBottomPaginationBlock,
} from '../../components/Common/Table'
import TableComponent from '../../components/Common/TableComponent'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import PageTitle from '../../components/PageTitle'
import { ACL_ACTION_TYPE, DATE_FORMAT_DEFAULT } from '../../constants'
import DashboardLayout from '../../layouts/DashboardLayout'
import AdvanceFilterBlock from './AdvanceFilterBlock'
import utils from '../../utils'

const BoardResolutionMinutesPage = props => {
  const { loadingAnimationStore, boardResolutionMinutesStore, history } = props

  const {
    listBoardHDQT,
    filterBoardHDQT,
    totalCount,
  } = boardResolutionMinutesStore

  const downloadFile = useCallback(
    async record => {
      try {
        loadingAnimationStore.showSpinner(true)
        const {
          data: attachmentBlob,
        } = await boardResolutionMinutesStore.getAttachmentBoardHDQT({
          recordId: record.id,
          fileId: record.file_id,
        })
        const {
          data: { attachments },
        } = await boardResolutionMinutesStore.getBoardResolutionMinutesDetail(
          record.id
        )
        const blob = new Blob([attachmentBlob], { type: 'application/pdf' })
        const attachmentInfo = attachments.find(
          attachment => attachment.id === record.file_id
        )
        FileDownload(blob, attachmentInfo.name)
      } catch (error) {
        console.error(error)
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    },
    [boardResolutionMinutesStore, loadingAnimationStore]
  )

  const tableColumn = [
    {
      title: 'Tên văn bản',
      align: 'left',
      render: record => (
        <Tooltip title={record?.document_name}>{record?.document_name}</Tooltip>
      ),
    },
    {
      title: 'Số quyết định ban hành',
      render: record => (
        <Tooltip title={record?.document_number}>
          <CellEclipseBox>{record?.document_number}</CellEclipseBox>
        </Tooltip>
      ),
    },
    {
      title: 'Ngày ban hành',
      render: record => {
        const formattedDate = moment(record?.issue_date).format(
          DATE_FORMAT_DEFAULT
        )
        return (
          <Tooltip title={formattedDate}>
            <CellEclipseBox>
              <time>{formattedDate}</time>
            </CellEclipseBox>
          </Tooltip>
        )
      },
    },
    {
      title: 'Phân loại',
      render: record => {
        const issueLevelLabel = utils.renderIssueLevel(record?.issue_level)
        return (
          <Tooltip title={issueLevelLabel}>
            <CellEclipseBox>{issueLevelLabel}</CellEclipseBox>
          </Tooltip>
        )
      },
    },
    // {
    //   title: 'Ban chủ trì xây dựng',
    //   render: record => (
    //     <Tooltip title={record?.contruction_board || '-'}>
    //       <CellEclipseBox>{record?.contruction_board || '-'}</CellEclipseBox>
    //     </Tooltip>
    //   ),
    // },
    {
      title: 'Trạng thái',
      render: record => {
        const statusLabelMap = {
          ABOLISHED: 'Đã bãi bỏ',
          EXPIRED: 'Hết hiệu lực',
          ACTIVE: 'Còn hiệu lực',
        }
        const statusLabel = statusLabelMap[record?.status] || ''
        return (
          <Tooltip title={statusLabel}>
            <CellEclipseBox>{statusLabel}</CellEclipseBox>
          </Tooltip>
        )
      },
    },
    // {
    //   title: 'Tài liệu đính kèm',
    //   render: record => (
    //     <Tooltip title="Tải tài liệu đính kèm">
    //       <Button
    //         type="primary"
    //         onClick={async event => {
    //           event.stopPropagation()
    //           await downloadFile(record)
    //         }}>
    //         <PaperClipOutlined className={'cursor-pointer'} /> Download
    //       </Button>
    //     </Tooltip>
    //   ),
    // },
  ]

  const onChangeTable = useCallback(
    (current, size) => {
      if (size !== filterBoardHDQT.size) {
        filterBoardHDQT.page = 1
        filterBoardHDQT.size = size
      } else {
        filterBoardHDQT.page = current
      }
      boardResolutionMinutesStore.setfilterBoardHDQT(filterBoardHDQT)
    },
    [boardResolutionMinutesStore, filterBoardHDQT]
  )

  const handleTabChange = useCallback(
    value => {
      boardResolutionMinutesStore.setfilterBoardHDQT({
        document_type: value,
        page: 1,
      })
    },
    [boardResolutionMinutesStore]
  )

  useEffect(() => {
    loadingAnimationStore.setTableLoading(true)
    boardResolutionMinutesStore
      .getBoardResolutionMinutes(filterBoardHDQT)
      .finally(() => loadingAnimationStore.setTableLoading(false))
    return () => boardResolutionMinutesStore.clearDocument()
  }, [boardResolutionMinutesStore, filterBoardHDQT, loadingAnimationStore])

  return (
    <DashboardLayout>
      <Helmet>
        <title>Quyết định nghị quyết HĐQT</title>
      </Helmet>
      <PageTitle
        location={props.location}
        title={'Quyết định nghị quyết HĐQT'}
        hiddenGoBack>
        <div>
          <Button
            style={{ margin: '0 15px' }}
            type={filterBoardHDQT.isOpen ? 'primary' : 'default'}
            ghost={filterBoardHDQT.isOpen}
            onClick={() => {
              if (filterBoardHDQT.isOpen) {
                boardResolutionMinutesStore.resetFilter()
              } else {
                boardResolutionMinutesStore.setfilterBoardHDQT({
                  isOpen: !filterBoardHDQT.isOpen,
                })
              }
            }}>
            {filterBoardHDQT.isOpen ? (
              <Space>
                <CloseCircleOutlined />
                Tắt tìm kiếm nâng cao
              </Space>
            ) : (
              <Space>
                <FilterOutlined />
                Tìm kiếm nâng cao
              </Space>
            )}
          </Button>
          <AccessControlAction
            aclActionType={ACL_ACTION_TYPE.create__BB_NQ_HDQT}>
            <Button
              onClick={() =>
                history.push('/board-resolution-minutes-hdqt/create')
              }
              style={{ marginBottom: 15 }}
              type={'primary'}>
              <PlusCircleOutlined />
              Tạo quyết định nghị quyết
            </Button>
          </AccessControlAction>
        </div>
      </PageTitle>
      {filterBoardHDQT.isOpen ? (
        <Fragment>
          <AdvanceFilterBlock />
          <div style={{ marginBottom: 16 }} />
        </Fragment>
      ) : null}
      <ContentBlockWrapper>
        <Tabs
          activeKey={filterBoardHDQT.document_type || 'QUYET_DINH'}
          onChange={handleTabChange}
          style={{ marginBottom: 16 }}>
          <Tabs.TabPane tab={'Quyết định'} key={'QUYET_DINH'} />
          <Tabs.TabPane tab={'Nghị quyết'} key={'NGHI_QUYET'} />
        </Tabs>
        <TableComponent
          onRow={record => {
            return {
              onClick: () =>
                history.push(
                  `/board-resolution-minutes-hdqt/view/${record.id}`
                ),
            }
          }}
          rowKey={() => uuid()}
          columns={tableColumn}
          dataSource={listBoardHDQT}
          pagination={false}
          onChange={onChangeTable}
          loading={loadingAnimationStore.tableLoading}
        />
        <TableBottomPaginationBlock>
          <Pagination
            current={filterBoardHDQT.page}
            pageSize={filterBoardHDQT.size}
            total={totalCount}
            onChange={onChangeTable}
            showSizeChanger={false}
            showLessItems
          />
        </TableBottomPaginationBlock>
      </ContentBlockWrapper>
    </DashboardLayout>
  )
}

BoardResolutionMinutesPage.propTypes = {}

export default memo(
  inject(
    'loadingAnimationStore',
    'documentStore',
    'boardResolutionMinutesStore'
  )(observer(BoardResolutionMinutesPage))
)
